import { useEffect, useState } from 'react';

import { Box, CircularProgress, Tab, Tabs, Typography } from '@mui/material';
import ManufacturerDropdown from './Components/ManufacturerDropdown';
import { LinkedManufacturesAction, MyBenefitsAction } from './APIs/action';
import { toast } from 'react-toastify';
import SocialSecurityBenefit from './Components/SSB';
import { BenefitType } from './constants';
import { trackAnalyticsEvent } from '../../../utils/clevertap';
import Entity from '../../../v3/Common/Entity';
import { useSelector } from 'react-redux';

const MyBenefits = () => {
  // Get manufacturer and entity from Redux via Entity component
  const { selectedSupplier: selectedManufacturer, selectedEntity: selectedCompanyEntity } = useSelector(
    (state) => state.entityReducer
  );
  
  const [benefitData, setBenefitData] = useState([]);
  const [socialSecurityBenefits, setSocialSecurityBenefits] = useState({});
  const [selectedTab, setSelectedTab] = useState('');
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    if (socialSecurityBenefits?.display_name) {
      setSelectedTab(socialSecurityBenefits.display_name);
    }
  }, [socialSecurityBenefits]);
  
  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };
  const getMyBenefitData = async (selectedManufacturer, selectedCompanyEntity) => {
    setLoader(true);
    // Clear previous data when changing manufacturer
    setBenefitData([]);
    setSocialSecurityBenefits({});
    setSelectedTab('');

    const { data, message, error } = await MyBenefitsAction(selectedManufacturer, selectedCompanyEntity);
    setLoader(false);

    if (!error) {
      if (data && data.length > 0) {
        setBenefitData(data);
        const socialSecurity = data.find(
          (benefit) =>
            benefit.display_name === BenefitType.SOCIAL_SECURITY_BENEFIT,
        );
        setSocialSecurityBenefits(socialSecurity || {});
      } else {
        setBenefitData([]);
        setSocialSecurityBenefits({});
      }
    } else {
      setBenefitData([]);
      setSocialSecurityBenefits({});
      toast.error(message);
    }
  };

	useEffect(() => {
		(selectedManufacturer && selectedCompanyEntity ) && getMyBenefitData(selectedManufacturer, selectedCompanyEntity);
	}, [selectedManufacturer, selectedCompanyEntity]);

  useEffect(() => {
    if (selectedManufacturer && benefitData.length > 0) {
      trackAnalyticsEvent('MY_BENEFIT_BENEFIT_COMPARISON_LOAD', {
        manufacturer_id: selectedManufacturer,
      });
    }
  }, [selectedManufacturer, benefitData]);

  const handleTabChangeWithTracking = (event, newValue) => {
    handleTabChange(event, newValue);

    // Track tab selection event
    if (newValue && selectedManufacturer) {
      trackAnalyticsEvent('MY_BENEFIT_TAB_CHANGE', {
        manufacturer_id: selectedManufacturer,
        benefit_type: newValue,
      });
    }
  };

  return (
    <Box sx={{ p: { xs: 2, md: 3 } }}>
      <Entity
        supplierLabel="Manufacturer"
        entityLabel="SAP Code"
        gridSizes={{
          supplier: { xs: 6, sm: 4 },
          entity: { xs: 6, sm: 4 }
        }}
      />
      {loader ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '70vh',
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
          <Typography
            variant='h2'
            sx={{ mb: 1 }}
          >
            Benefits Type
          </Typography>

          <Box sx={{ mb: 3, overflowX: 'auto' }}>
            <Tabs
              value={selectedTab}
              onChange={(_, newValue) => {
                if (newValue !== null) handleTabChangeWithTracking(_, newValue);
              }}
              sx={{ flexWrap: 'wrap' }}
            >
              {benefitData.length > 0 ? (
                benefitData.map((benefit, index) => (
                  <Tab
                    key={index}
                    label={benefit.display_name}
                    value={benefit.display_name}
                    sx={{
                      fontWeight: 'bold',
                      fontSize: '1rem',
                      textTransform: 'capitalize',
                    }}
                  />
                ))
              ) : (
                <p>No tabs available</p>
              )}
            </Tabs>
          </Box>
          {selectedTab === BenefitType.SOCIAL_SECURITY_BENEFIT &&
            (socialSecurityBenefits &&
            Object.keys(socialSecurityBenefits).length > 0 ? (
              <SocialSecurityBenefit
                benefits={socialSecurityBenefits}
                selectedManufacturer={selectedManufacturer}
                selectedCompanyEntity={selectedCompanyEntity}
              />
            ) : (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '200px',
                }}
              >
                <CircularProgress />
              </Box>
            ))}
        </>
      )}
    </Box>
  );
};

export default MyBenefits;
